<template>
  <div class="card special transition-all duration-1000 ease-in-out">
    <div class="card-header">
      <h2 class="card-heading mt-1">Container Search</h2>
    </div>

    <div class="card-content mb-2">
      <div class="flex flex-row-reverse flex-wrap">
        <div class="w-full relative">
          <form action="" @submit.prevent="search()" class="relative">
            <input
                required
                v-model="form.container"
                class="w-full outline-none border-2 border-slate-400 focus:border-primary transition-all duration-200 px-3 py-2 rounded-lg"
                type="text"
                placeholder="Example Search: APRU5103311"
                name=""
                id=""
            />
            <button v-if="result" @click="resetResults()"
                    style="right: 0.25rem;
    top: 0.25rem;
    width: 2rem;
    height: 2rem;"
                    class="font-semibold text-gray-600 hover:text-gray-800 cursor-pointer absolute r-4 t-4">
              <i class="fad fa-times-circle"></i>
            </button>
          </form>
        </div>
      </div>

    </div>

    <div v-if="loading" class="w-full my-2">
      <div>
        <p class="text-center text-lg">
          <i class="fad fa-spinner fa-spin"></i>
        </p>
      </div>
    </div>

    <div class="divide-y divide-slate-200" v-if="result">
      <div
          v-for="item in result"
          v-bind:key="item.pos"
          class="py-3 px-2">
        <div class="flex justify-between">
          <!-- <div class="w-full font-semibold text-slate-800">{{ item.detail_name }} • <span
            class="text-sec">{{ item.status === 1 ? "In Port" : "Not in Port" }}</span>
          </div> -->
          <div class="w-full font-semibold text-slate-800">{{ item.detail_name }} • <span
              class="text-sec">
              <!-- {{ item.status === 1 ? "In Port" : "Not in Port" }} -->
            </span>
          </div>
        </div>
        <div class="flex flex-col text-xs">
          <div class="container-detail-grid">
            <span class="text-slate-600 font-medium" for="">Voyage: </span>
            <span class="text-sec">{{ item.voyage_name || 'NA' }}</span>
            <span class="text-slate-600 font-medium" for="">Arrival Date: </span>
            <span class="text-sec">{{ item.eta || 'NA' }}</span>
            <span class="text-slate-600 font-medium" for="">Discharge Date: </span>
            <span class="text-sec">{{ item.tallied_date || 'NA' }}</span>
            <!-- <span class="text-slate-600 font-medium" for="">Empty Date: </span>
            <span class="text-sec">{{ item.empty_date || 'NA' }}</span> -->
            <span class="text-slate-600 font-medium" for="">Loading Port: </span>
            <span class="text-sec">{{ item.loading_port || 'NA' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import BandharuService from "@/services/bandharu.service";

@Component({})
export default class ContainerSearch extends Vue {
  private service = new BandharuService();

  private settings = {
    userDropdown: false,
    notificationDropdown: false,
  };

  private loading = false;

  private result = null;

  private form = {
    container: "",
  };

  resetResults() {
    this.form.container = "";
    this.result = null;
  }

  search() {
    this.loading = true;

    this.service.searchContainer(this.form.container)
        .then((res) => {
          console.log(res);
          this.result = res;
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error Searching Container");
        });
  }

  viewUserDropdown() {
    this.settings.userDropdown = true;
  }

  hideUserDropdown() {
    this.settings.userDropdown = false;
  }

  viewNotifications() {
    this.settings.notificationDropdown = true;
  }

  hideNotifications() {
    this.settings.notificationDropdown = false;
  }
}
</script>
